import {apiClient} from "@/api/setupApi"

const BASE_API = "v1/motivation/admin/miopia"

export default {
  getPromotions(): Promise<any> {
    return apiClient.get(`${BASE_API}/`)
  },
  updatePromotion(pk: string, data: any): Promise<any> {
    return apiClient.patch(`${BASE_API}/${pk}/`, data)
  },
  getLetters(pk: string, params?: any): Promise<any> {
    return apiClient.get(`${BASE_API}/${pk}/letters/`, {params})
  },
  getBonuses(pk: string, params?: any): Promise<any> {
    return apiClient.get(`${BASE_API}/${pk}/bonuses/`, {params})
  },
  // filter: "letters" | "bonus" — id клиента здесь не совпадает с client.id из строк таблиц,
  // но именно он подходит для query-параметра client_id
  getClientFilterOptions(pk: string, filter: "letters" | "bonus"): Promise<any> {
    return apiClient.get(`${BASE_API}/${pk}/filters/`, {params: {filter}})
  },
}
